import axios from 'axios';
import { PayloadAction, createAsyncThunk, createSlice, AnyAction } from '@reduxjs/toolkit';
import ChecklistService from '../services/checklist.service';

interface IChecklistState {
    [key: string]:
        | {
              IMONumber: string;
              Port: string;
              PdfBlob: Blob | undefined;
              IsLoading: boolean;
              ErrorMessage: string | undefined;
          }
        | undefined;
}

const initialState: IChecklistState = {};

const Fetch = {
    GenerateChecklistPdf: createAsyncThunk(
        'checklist/GeneratePdfChecklist',
        async ({ imoNumber, port, classNumber, eta, vesselName }: { imoNumber: string; port: string; classNumber: string; eta: string; vesselName: string }, { rejectWithValue }) => {
            try {
                const request = { vesselImoNumber: imoNumber, port, classNumber, eta, vesselName };
                const pdfBlob = await ChecklistService.generateChecklistPdf(request);
                return { IMONumber: imoNumber, Port: port, pdfBlob };
            } catch (err) {
                if (axios.isAxiosError(err)) {
                    return rejectWithValue(err.response?.data || err.message);
                } else {
                    return rejectWithValue('An unknown error occurred');
                }
            }
        }
    )
};

const ChecklistSlice = createSlice({
    name: 'checklist',
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        // GenerateChecklistPdf
        builder.addCase(Fetch.GenerateChecklistPdf.pending, (state, action: AnyAction) => {
            const { imoNumber, port } = action.meta.arg;
            state[imoNumber] = { IMONumber: imoNumber, Port: port, PdfBlob: undefined, IsLoading: true, ErrorMessage: undefined };
        });
        builder.addCase(Fetch.GenerateChecklistPdf.fulfilled, (state, action: PayloadAction<{ IMONumber: string; Port: string; pdfBlob: Blob }>) => {
            const { IMONumber, Port, pdfBlob } = action.payload;
            state[IMONumber] = { IMONumber: IMONumber, Port: Port, PdfBlob: pdfBlob, IsLoading: false, ErrorMessage: undefined };
        });
        builder.addCase(Fetch.GenerateChecklistPdf.rejected, (state, action: AnyAction) => {
            const { imoNumber, port } = action.meta.arg;
            state[imoNumber] = { IMONumber: imoNumber, Port: port, PdfBlob: undefined, IsLoading: false, ErrorMessage: action.payload };
        });
    }
});

export const ChecklistFetch = Fetch;
export const ChecklistAction = ChecklistSlice.actions;
export const ChecklistReducer = ChecklistSlice.reducer;
